module.exports = __webpack_public_path__ + "static/media/bell.879875ef.svg";